// @flow
import React, { Component } from 'react';

import Header from '../Header.jsx';
import ContentBox from '../ContentBox.jsx';
import PageHeader from '../PageHeader.jsx';

import ActiveAccount from './ActiveAccount.jsx';
import AllAccountsTable from './AllAccountsTable.jsx';

import styles from '../../styles/accountPages/AccountPage.scss';

type Props = {
  activeAccount: Object,
  updateAccount: Function,
}

class AccountPage extends Component<Props> {
  componentDidMount() {
    document.title = 'Account - HFA EHR';
  }

  render() {
    return (
      <div className={styles.accountPage}>
        <Header />
        <div className={styles.pageContent}>
          <PageHeader title='Account Management' />
          <ContentBox title='Your Account'>
            <ActiveAccount />
          </ContentBox>
          <ContentBox title='All Accounts'>
            <AllAccountsTable />
          </ContentBox>
        </div>
      </div>
    );
  }
}

export default AccountPage;



// WEBPACK FOOTER //
// ./client/src/components/accountPages/AccountPage.jsx